import React, { useState, useEffect } from 'react';
import './styles.css';
// index.js または App.js
import "academicons/css/academicons.min.css";

const AudioCell = ({ audioSrc, transcriptOverride }) => {
  const [transcript, setTranscript] = useState('Loading transcript...');

  useEffect(() => {
    if (transcriptOverride) {
      setTranscript(transcriptOverride);
      return;
    }
    const txtPath = audioSrc.replace('.wav', '.txt');
    fetch(txtPath)
      .then(res => {
        if (!res.ok) throw new Error();
        return res.text();
      })
      .then(text => setTranscript(text.trim()))
      .catch(() => setTranscript('Transcript unavailable'));
  }, [audioSrc, transcriptOverride]);

  return (
    <td className="table-cell">
      <div className="audio-box">
        <audio controls className="audio-player">
          <source src={audioSrc} type="audio/wav" />
          Your browser does not support the audio element.
        </audio>
        <div className="transcript">
          <strong>Transcript:</strong><br />
          {transcript}
        </div>
      </div>
    </td>
  );
};

const LlamaMimiPage = () => {
  const naturalExamples = [
    {
      prompt: `${process.env.PUBLIC_URL}/data/prompt/natural/great_day_gt.wav`,
      llamaMimi1B: `${process.env.PUBLIC_URL}/data/continuation/natural/Llama-3.2-1B_all-q4-s1024/great_day_gt.wav`,
      llamaMimi8B: `${process.env.PUBLIC_URL}/data/continuation/natural/Llama-3.1-8B_all-q4-s1024/great_day_gt.wav`,
      gslm: `${process.env.PUBLIC_URL}/data/continuation/natural/gslm/great_day_gt.wav`,
      twist: `${process.env.PUBLIC_URL}/data/continuation/natural/TWIST-7B/great_day_gt.wav`
    },
    {
      prompt: `${process.env.PUBLIC_URL}/data/prompt/natural/how_are_you_gt.wav`,
      llamaMimi1B: `${process.env.PUBLIC_URL}/data/continuation/natural/Llama-3.2-1B_all-q4-s1024/how_are_you_gt.wav`,
      llamaMimi8B: `${process.env.PUBLIC_URL}/data/continuation/natural/Llama-3.1-8B_all-q4-s1024/how_are_you_gt.wav`,
      gslm: `${process.env.PUBLIC_URL}/data/continuation/natural/gslm/how_are_you_gt.wav`,
      twist: `${process.env.PUBLIC_URL}/data/continuation/natural/TWIST-7B/how_are_you_gt.wav`
    },
    {
      prompt: `${process.env.PUBLIC_URL}/data/prompt/natural/one_two_three_gt.wav`,
      llamaMimi1B: `${process.env.PUBLIC_URL}/data/continuation/natural/Llama-3.2-1B_all-q4-s1024/one_two_three_gt.wav`,
      llamaMimi8B: `${process.env.PUBLIC_URL}/data/continuation/natural/Llama-3.1-8B_all-q4-s1024/one_two_three_gt.wav`,
      gslm: `${process.env.PUBLIC_URL}/data/continuation/natural/gslm/one_two_three_gt.wav`,
      twist: `${process.env.PUBLIC_URL}/data/continuation/natural/TWIST-7B/one_two_three_gt.wav`
    },
    {
      prompt: `${process.env.PUBLIC_URL}/data/prompt/natural/play_gt.wav`,
      llamaMimi1B: `${process.env.PUBLIC_URL}/data/continuation/natural/Llama-3.2-1B_all-q4-s1024/play_gt.wav`,
      llamaMimi8B: `${process.env.PUBLIC_URL}/data/continuation/natural/Llama-3.1-8B_all-q4-s1024/play_gt.wav`,
      gslm: `${process.env.PUBLIC_URL}/data/continuation/natural/gslm/play_gt.wav`,
      twist: `${process.env.PUBLIC_URL}/data/continuation/natural/TWIST-7B/play_gt.wav`
    },
    {
      prompt: `${process.env.PUBLIC_URL}/data/prompt/natural/swim_gt.wav`,
      llamaMimi1B: `${process.env.PUBLIC_URL}/data/continuation/natural/Llama-3.2-1B_all-q4-s1024/swim_gt.wav`,
      llamaMimi8B: `${process.env.PUBLIC_URL}/data/continuation/natural/Llama-3.1-8B_all-q4-s1024/swim_gt.wav`,
      gslm: `${process.env.PUBLIC_URL}/data/continuation/natural/gslm/swim_gt.wav`,
      twist: `${process.env.PUBLIC_URL}/data/continuation/natural/TWIST-7B/swim_gt.wav`
    }
  ];

  const speakerExamples = [
    {
      prompt: `${process.env.PUBLIC_URL}/data/prompt/gslm/hi.wav`,
      llamaMimi1B: `${process.env.PUBLIC_URL}/data/continuation/gslm/Llama-3.2-1B_all-q4-s1024/hi.wav`,
      llamaMimi8B: `${process.env.PUBLIC_URL}/data/continuation/gslm/Llama-3.1-8B_all-q4-s1024/hi.wav`,
      gslm: `${process.env.PUBLIC_URL}/data/continuation/gslm/gslm/hi.wav`,
      twist: `${process.env.PUBLIC_URL}/data/continuation/gslm/TWIST-7B/hi.wav`
    },
    {
      prompt: `${process.env.PUBLIC_URL}/data/prompt/gslm/reality.wav`,
      llamaMimi1B: `${process.env.PUBLIC_URL}/data/continuation/gslm/Llama-3.2-1B_all-q4-s1024/reality.wav`,
      llamaMimi8B: `${process.env.PUBLIC_URL}/data/continuation/gslm/Llama-3.1-8B_all-q4-s1024/reality.wav`,
      gslm: `${process.env.PUBLIC_URL}/data/continuation/gslm/gslm/reality.wav`,
      twist: `${process.env.PUBLIC_URL}/data/continuation/gslm/TWIST-7B/reality.wav`
    }
  ];

  const ablationExamples = [
    {
      llamaMimi1Bq2: `${process.env.PUBLIC_URL}/data/ablation/q2.wav`,
      llamaMimi1Bq4: `${process.env.PUBLIC_URL}/data/ablation/q4.wav`,
      llamaMimi1Bq8: `${process.env.PUBLIC_URL}/data/ablation/q8.wav`
    },
  ];

  return (
    <div className="page">

      {/* Header */}
      <div className="header">
        <h1>
          Llama-Mimi: Exploring the Limits of Flattened Speech Language Modeling
        </h1>
        <div className="authors">
          <span><a href="#">Issa Sugiura</a><sup>1,2</sup></span>
          <span><a href="#">Shuhei Kurita</a><sup>3,2</sup></span>
          <span><a href="#">Yusuke Oda</a><sup>2</sup></span>
          <span><a href="#">Ryuichiro Higashinaka</a><sup>4,2</sup></span>
        </div>
        <div className="affiliations">
          <sup>1</sup>Kyoto University, <sup>2</sup>NII LLMC, <sup>3</sup>NII, <sup>4</sup>Nagoya University
        </div>
        <div className="links">
                  <a
  href="https://arxiv.org/abs/2509.14882"
  className="btn"
>
  <i className="ai ai-arxiv ai-lg"></i>
  <span>arXiv</span>
</a>
          <a href="https://huggingface.co/llm-jp/Llama-Mimi-1.3B" className="btn">🤗 Model</a>
          <a
  href="https://github.com/llm-jp/llama-mimi"
  className="btn"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    style={{ marginRight: "8px" }}
  >
    <path d="M12 .5C5.73.5.5 5.73.5 12c0 5.1 3.29 9.42 7.86 10.96.58.1.79-.25.79-.56
    0-.28-.01-1.02-.02-2-3.2.7-3.88-1.54-3.88-1.54-.53-1.36-1.29-1.72-1.29-1.72-1.05-.72.08-.7.08-.7
    1.16.08 1.77 1.19 1.77 1.19 1.03 1.77 2.7 1.26 3.36.96.1-.75.4-1.26.72-1.55-2.55-.29-5.23-1.28-5.23-5.7
    0-1.26.45-2.28 1.18-3.09-.12-.29-.51-1.46.11-3.04 0 0 .96-.31 3.15 1.18A10.9 10.9 0 0112 6.8c.97.01 1.95.13
    2.87.38 2.18-1.49 3.14-1.18 3.14-1.18.62 1.58.24 2.75.12 3.04.73.81 1.18 1.83 1.18 3.09
    0 4.43-2.68 5.41-5.24 5.7.41.36.77 1.08.77 2.18
    0 1.57-.01 2.83-.01 3.21 0 .31.21.67.79.56A10.52 10.52 0 0023.5 12C23.5 5.73 18.27.5 12 .5z"/>
  </svg>
  Code
          </a>
          <a href="https://speed1313.github.io/posts/llama-mimi" className="btn">📝 Blog</a>
        </div>
      </div>

      {/* Abstract */}
      <div className="section">
        <h2 className="section-title">Abstract</h2>
        <div className="prose">
          <p>
            Speech Language Models (SpeechLMs) model tokenized speech to capture both semantic and acoustic information. When neural audio codecs based on Residual Vector Quantization (RVQ) are used as audio tokenizers, they produce multiple discrete tokens per time step, yielding inherently multi-level representations. To process these multi-level tokens together, prior work typically adopts hierarchical architectures to capture this structure. In contrast, recent progress in NLP has progressively reduced architectural inductive biases, moving toward simpler and more scalable single-Transformer architectures. In this work, we propose Llama-Mimi, which flattens multi-level RVQ tokens produced by the Mimi neural audio codec into a single sequence and models them autoregressively with a Transformer decoder. We show that Llama-Mimi outperforms a CSM-based hierarchical model on most tasks and achieves the best performance on acoustic consistency. Our models, code, and speech samples are publicly available.
          </p>
        </div>
      </div>

      {/* Teaser */}
      <div className="section bg-gray">
        <div className="teaser">
          <div className="teaser-box">
            <img src={`${process.env.PUBLIC_URL}/data/Flattened_vs_Hierarchical.svg`} alt="Flattened (Llama-Mimi) vs. Hierarchical (CSM) Architecture Comparison" />
          </div>
          <p>
            Flattened (Llama-Mimi, Ours) vs. hierarchical (CSM) architectures. In Llama-Mimi, discrete audio tokens from Mimi are flattened into a single sequence and modeled by a single Transformer decoder, whereas the hierarchical model separates temporal and depth-wise modeling across two Transformer decoders.
          </p>
        </div>
      </div>

      {/* Generation Examples */}
      <div className="section bg-gray">
        <h2 className="section-title">Generation Examples</h2>
        <p className="section-subtitle">
          We present audio generation examples to qualitatively evaluate the performance of Llama-Mimi against baseline models.
        </p>
        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Prompt</th>
                <th>Llama-Mimi-1B</th>
                <th>Llama-Mimi-8B</th>
                <th>GSLM</th>
                <th>TWIST-7B</th>
              </tr>
            </thead>
            <tbody>
              {naturalExamples.map((ex, idx) => (
                <tr key={idx}>
                  <AudioCell audioSrc={ex.prompt} />
                  <AudioCell audioSrc={ex.llamaMimi1B} />
                  <AudioCell audioSrc={ex.llamaMimi8B} />
                  <AudioCell audioSrc={ex.gslm} />
                  <AudioCell audioSrc={ex.twist} />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Speaker Consistency */}
      <div className="section">
        <h2 className="section-title">Speaker Consistency</h2>
        <p className="section-subtitle">
          Llama-Mimi demonstrates voice cloning capabilities by maintaining speaker identity from the prompt audio.
        </p>
        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Prompt</th>
                <th>Llama-Mimi-1B</th>
                <th>Llama-Mimi-8B</th>
                <th>GSLM</th>
                <th>TWIST-7B</th>
              </tr>
            </thead>
            <tbody>
              {speakerExamples.map((ex, idx) => (
                <tr key={idx}>
                  <AudioCell audioSrc={ex.prompt} />
                  <AudioCell audioSrc={ex.llamaMimi1B} />
                  <AudioCell audioSrc={ex.llamaMimi8B} />
                  <AudioCell audioSrc={ex.gslm} />
                  <AudioCell audioSrc={ex.twist} />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Ablation Study */}
      <div className="section">
        <h2 className="section-title">Effect of Quantizer numbers</h2>
        <p className="section-subtitle">
          Increasing the number of quantizers enhances audio quality and speaker similarity but may compromise linguistic accuracy.
        </p>
        <div className="table-container">
          <table className="table">
            <thead>
              <tr>
                <th>Llama-Mimi-1B-q2</th>
                <th>Llama-Mimi-1B-q4</th>
                <th>Llama-Mimi-1B-q8</th>
              </tr>
            </thead>
            <tbody>
              {ablationExamples.map((ex, idx) => (
                <tr key={idx}>
                  <AudioCell audioSrc={ex.llamaMimi1Bq2} />
                  <AudioCell audioSrc={ex.llamaMimi1Bq4} />
                  <AudioCell audioSrc={ex.llamaMimi1Bq8} />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* BibTeX */}
      <div className="section bg-gray">
        <div className="bibtex-header">
          <h2 className="section-title">BibTeX</h2>
          <button
            className="btn"
            onClick={() => {
              const bibtex = `@misc{sugiura2026llamamimiexploringlimitsflattened,
      title={Llama-Mimi: Exploring the Limits of Flattened Speech Language Modeling},
      author={Issa Sugiura and Shuhei Kurita and Yusuke Oda and Ryuichiro Higashinaka},
      year={2026},
      eprint={2509.14882},
      archivePrefix={arXiv},
      primaryClass={cs.CL},
      url={https://arxiv.org/abs/2509.14882},
}`;
              navigator.clipboard.writeText(bibtex);
              alert('BibTeX copied to clipboard!');
            }}
          >
            📋 Copy
          </button>
        </div>
        <pre className="bibtex-code">
{`@misc{sugiura2026llamamimiexploringlimitsflattened,
      title={Llama-Mimi: Exploring the Limits of Flattened Speech Language Modeling},
      author={Issa Sugiura and Shuhei Kurita and Yusuke Oda and Ryuichiro Higashinaka},
      year={2026},
      eprint={2509.14882},
      archivePrefix={arXiv},
      primaryClass={cs.CL},
      url={https://arxiv.org/abs/2509.14882},
}`}
        </pre>
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>
          This page was built using the <a href="https://github.com/eliahuhorwitz/Academic-project-page-template">Academic Project Page Template</a>...<br />
          This website is licensed under a <a href="http://creativecommons.org/licenses/by-sa/4.0/">CC BY-SA 4.0</a>.
        </p>
      </footer>
    </div>
  );
};

export default LlamaMimiPage;
